import { render, staticRenderFns } from "./SparkDataItem.vue?vue&type=template&id=f66be47e&scoped=true&"
import script from "./SparkDataItem.vue?vue&type=script&lang=js&"
export * from "./SparkDataItem.vue?vue&type=script&lang=js&"
import style0 from "./SparkDataItem.vue?vue&type=style&index=0&id=f66be47e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66be47e",
  null
  
)

export default component.exports